import { balancesApi } from './balances'
import { allowancesApi } from './allowances'

export const multicalls = {
  balances: balancesApi,
  allowances: allowancesApi,
}
